import { render, staticRenderFns } from "./DepartmentAdd.vue?vue&type=template&id=8456e000&"
import script from "./DepartmentAdd.vue?vue&type=script&lang=js&"
export * from "./DepartmentAdd.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports